import { CoreInterfaces, DTOs } from "src/core/Models";

export const AnnualReportingListedCompaniesProcessor: CoreInterfaces.QuestionProcessors =
  (appState: CoreInterfaces.AppState, serviceDTO: DTOs.ServiceDTO) => {
    return {};
  };
